<template>
  <mu-dialog title="" width="500px" :open.sync="reportFlag" @close="reportFlag = false">
    <div style="width: 100%; display: flex; position: relative">
      <img src="@/assets/template5/close.png" style="width: 20px; height: 20px; position: absolute; right: 0px; top: 0px" @click="reportFlag = false" />
      <img :src="appInfo && appInfo.image" alt="" style="width: 70px; height: 70px; border-radius: 10px" />
      <div style="font-size: 13px; margin-left: 10px; flex: 1; display: flex; flex-direction: column">
        <div style="display: flex">
          <span style="color: #999; margin-right: 15px">{{ $t('index.yy') }}</span>
          <span style="color: #333">{{ appInfo.ipa_name }}</span>
        </div>
        <div style="display: flex; margin-top: 3px">
          <span style="color: #999; margin-right: 15px">{{ $t('index.platform') }}</span>
          <span style="color: #333">{{ appInfo.mimetype }}</span>
        </div>
        <div style="display: flex; margin-top: 3px">
          <span style="color: #999; margin-right: 15px">{{ $t('index.baoming') }}</span>
          <span style="color: #333">{{ appInfo.identifier }}</span>
        </div>
        <div style="display: flex; margin-top: 3px">
          <span style="color: #999; margin-right: 15px">版本</span>
          <span style="color: #333">{{ appInfo.xlversion }}</span>
        </div>
      </div>
    </div>
    <div style="width: 100%; margin-top: 5px; background-color: #fff1e9; border-radius: 5px; padding: 5px 10px">
      <img src="@/assets/template5/info.png" style="width: 18px; height: 18px; margin: 5px 8px 0 0" />
      <span style="font-size: 13px; color: #333">{{ $t('report.reportTip1') }}</span>
    </div>
    <div style="width: 100%; margin: 5px 0 8px 0; background-color: #fff1e9; border-radius: 5px; padding: 5px 10px">
      <span style="font-size: 13px; color: #333">{{ $t('report.reportTip2') }}</span>
    </div>
    <form onsubmit="return false;">
      <div class="ui-form-item ui-border-b" style="border-bottom: 1px solid #ccc; padding: 0px 0; display: flex; flex-direction: column">
        <div style="margin-bottom: 4px">
          <span style="color: #d7524a; margin-right: 5px">*</span>
          <span style="margin-bottom: 5px; color: #222">{{ $t('report.contentLable') }}：</span>
        </div>
        <textarea v-model="title" rows="2" style="border: none; outline: none" :placeholder="$t('index.pleaseInput')"></textarea>
      </div>
      <div class="ui-form-item ui-border-b" style="border-bottom: 1px solid #ccc; padding: 2px 0">
        <div style="width: 70px">
          <span>{{ $t('index.name') }}：</span>
        </div>
        <input v-model="username" type="text" :placeholder="$t('index.pleaseInput') + $t('index.name')" style="border: none; outline: none" />
      </div>
      <div class="ui-form-item ui-border-b" style="border-bottom: 1px solid #ccc; padding: 2px 0">
        <div style="width: 70px">
          <span>{{ $t('index.IDnumber') }}：</span>
        </div>
        <input v-model="sf" type="text" :placeholder="$t('index.pleaseInput') + $t('index.IDnumber')" style="border: none; outline: none" />
      </div>

      <!-- 图片选择 -->
      <div class="ui-form-item ui-border-b" style="border-bottom: 1px solid #ccc; padding: 2px 0">
        <div style="width: 70px">
          <span>{{ $t('report.capture') }}：</span>
        </div>
        <div style="display: flex; flex-direction: column">
          <div style="display: flex">
            <img :src="src" style="width: 50px; height: 50px; margin-right: 10px" alt="" v-for="(src, index) in imageList" :key="index" />
            <div v-if="imageList.length < 4" @click="clickUpload" style="width: 50px; height: 50px; background-color: #fcfcfc; border-radius: 8px; border: 1px solid #dee5f2; display: flex; justify-content: center; align-items: center">
              <span style="font-size: 16px; color: #174fc2">+</span>
            </div>
          </div>
          <span style="color: #999; font-size: 12px">{{ $t('report.captureTips') }}</span>
        </div>
        <input type="file" id="uploadInput" @change="upload" accept="image/*" :multiple="false" style="display: none" />
      </div>

      <div class="ui-form-item ui-border-b" style="border-bottom: 1px solid #ccc; padding: 2px 0">
        <div style="width: 70px">
          <span>{{ $t('index.phonenumber') }}：</span>
        </div>
        <input v-model="mobile" type="text" :placeholder="$t('index.pleaseInput') + $t('index.phonenumber')" style="border: none; outline: none" />
      </div>
      <div class="ui-form-item ui-border-b" style="border-bottom: 1px solid #ccc; padding: 2px 0">
        <div style="width: 70px">
          <span>{{ $t('index.identifyingcode') }}：</span>
        </div>

        <div style="width: 100%; display: flex">
          <input v-model="cache" type="text" :placeholder="$t('index.pleaseInput') + $t('index.identifyingcode')" style="flex: 1; border: none; outline: none" />
          <button class="ui-btn" @click="sendSms" style="margin-top: 6px; margin-left: 5px">
            {{ $t('index.Verification') }}
          </button>
        </div>
      </div>
    </form>
    <div style="margin-top: 8px">
      <mu-button full-width color="#b5c7ff" textColor="#fff" large @click="saveReport">{{ $t('index.tijiao') }}</mu-button>
      <div style="width: 100%; display: flex; flex-direction: column; font-size: 12px; margin-top: 8px">
        <span>1.{{ $t('report.captureTips1') }}</span>
        <span style="color: #e42222">2.{{ $t('report.captureTips2') }}</span>
      </div>
    </div>
    <!-- <mu-button slot="actions" color="#1890ff" textColor="#fff" @click="reportFlag = false">{{ $t('index.qx') }}</mu-button>
    <mu-button slot="actions" color="#1890ff" textColor="#fff" @click="saveReport">{{ $t('index.tijiao') }}</mu-button> -->
  </mu-dialog>
</template>

<script>
import awsUpload from './awsUpload';
export default {
  props: {
    appid: {
      type: Number,
      required: true,
      default: () => {
        return '';
      },
    },
    appInfo: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    baseUrl: {
      type: String,
      required: true,
      default: () => {
        return '';
      },
    },
  },
  name: 'report',
  data() {
    return {
      reportFlag: false,
      title: '',
      cache: '',
      mobile: '',
      username: '',
      sf: '',
      imageList: [],
    };
  },
  methods: {
    clickUpload() {
      document.getElementById('uploadInput').click();
    },
    async upload(event) {
      let file = event.target.files[0];
      if (file) {
        this.uploadImage(file).then(url => {
          this.imageList.push(url);
        });
      }
    },
    uploadImage(file) {
      /* 改为亚马逊s3 */
      return new Promise((resolve, rejecct) => {
        awsUpload.uploadToS3(file, 'qwe/').then(uploadInstance => {
          uploadInstance.send((err, result) => {
            if (err) {
              rejecct(err);
            } else {
              resolve(result.Location);
            }
          });
        });
      });
    },
    saveReport() {
      if (this.imageList.length < 3) {
        this.$toast.message({
          close: false,
          position: 'top',
          message: this.$t('report.captureToast'),
        });
        return;
      }
      this.loading = true;
      const params = {
        username: this.username,
        sf: this.sf,
        title: this.title,
        cache: this.cache,
        mobile: this.mobile,
        appid: this.appid,
        // appid: '26432',
        // image: 'https://umedia.oss-cn-beijing.aliyuncs.com/20250204/22ddde91fe07e808c126e2c85d16566efb404547.jpg',
      };
      if (this.imageList.length > 0) {
        params.image = this.imageList.toString();
      }
      const formData = new FormData();
      Object.keys(params).forEach(key => {
        formData.append(key, params[key]);
      });
      this.$axios({
        method: 'post',
        url: this.baseUrl + '/api/Tfsign/report',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: formData,
      })
        .then(({ data }) => {
          this.loading = false;
          if (data.code === 1) {
            this.reportFlag = false;
            this.$toast.message({
              close: false,
              position: 'top',
              message: this.$t('index.jbcg'),
            });
          } else {
            this.$toast.message({
              close: false,
              position: 'top',
              message: this.$t('index.jbsb'),
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    sendSms() {
      // 发送验证码
      if (!this.mobile) {
        this.$toast.message({
          close: false,
          position: 'top',
          message: this.$t('index.qssjh'),
        });
        return;
      }
      const params = {
        mobile: this.mobile,
        event: 'report',
      };
      const formData = new FormData();
      Object.keys(params).forEach(key => {
        formData.append(key, params[key]);
      });
      this.$axios({
        method: 'post',
        url: this.baseUrl + '/api/Sms/send',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: formData,
      })
        .then(({ data }) => {
          if (data.code === 1) {
            this.$toast.message({
              close: false,
              position: 'top',
              message: this.$t('index.hqcg'),
            });
          } else {
            this.$toast.message({
              close: false,
              position: 'top',
              message: this.$t('index.hqsb'),
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.close {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #666;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
}
.confirm {
  // width: 68px;
  padding: 0 25px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  background-color: #1890ff;
  font-size: 14px;
  border-radius: 16px;
}
@import url(@/assets/theme.less);
</style>
